import React, { useEffect } from "react";
import s from "./technologyCardLora.module.css";
import Futter from "../futter/Futter";
import RS_M from "../../image/RS_M.png";
import Pulsar_U from "../../image/Pulsar_U.png";
import Konverter_485_232 from "../../image/Konverter_485_232.png";
import Povtoritel_RS_1 from "../../image/Povtoritel_RS_1.png";
import RS_v_USB from "../../image/RS_v_USB.png";
import IP_15_60 from "../../image/IP_15_60.png";
import { useDispatch, useSelector } from "react-redux";
import Mult from "./Mult";
import { useNavigate } from "react-router-dom";
import { catalogActReducer, changeCurrProd } from "../../redux/slices/catalogSlice";
import { selectStart } from "../../redux/selectors";
import { startMult } from "../../redux/slices/navigateSlice";
import { HiOutlineChevronRight } from "react-icons/hi2";
import PageHelmet from "../PageHelmet";

const TechnologyCardRS = () => {


  const navigate = useNavigate()
  const dispatch = useDispatch()
  const start = useSelector(selectStart)

  const prod = [['Теплосчетчик механический «Экохит М» с интерфейсом RS-485', 'Экохит М PS485 DN15',
  RS_M, [1, 0, 0]],
  ['Теплосчетчик ультразвуковой Экохит У с интерфейсом RS-485', 'Экохит У PS485 DN15',
  Pulsar_U, [1, 1, 0]],
  ['Повторитель интерфейсов RS-485', 'Повторитель интерфейсов RS-485',
  Povtoritel_RS_1, [4, 0, 0]],
   ['Конвертер RS-485/USB', 'Конвертер RS-485/ USB Пульсар',
  RS_v_USB, [4, 0, 0]],
   ['Конвертер RS-485/RS-232 Пульсар', 'Конвертер RS-485/RS-232 Пульсар',
  Konverter_485_232, [4, 0, 0]],
  
  ['Источник питания ИП15-60, 3А', 'Источники питания Пульсар',
  IP_15_60, [5, 0, 0]],



  ]

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {

    setTimeout(() => {
      if (start[3]) {
        let a = [...start]
        a.splice(3, 1, false)
        dispatch(startMult(a))
      }
    }, 7000)
  }, [dispatch, start]);
  const onClick = (catalog, product) => {

    dispatch(catalogActReducer(catalog))
    dispatch(changeCurrProd(product))
    navigate('/product')
  }
  const products = prod.map((el, i) => {
    return (
      <div onClick={() => {
        onClick(el[3], el[1])
      }} key={el[1]} className={s.blockCatalog}>
        <p className={s.numberPoductCatalog}>{'0' + (i + 1)}</p>
        <p className={s.poductCatalog}>
          {el[0]}
        </p>
        <img className={s.svkh} src={el[2]} alt="" />
      </div>
    )
  })
  return (
    <div>
      <PageHelmet />
      {(start[1] && !start[1]) ? <Mult close={() => {       // убрать !start[1]
        start.splice(3, 1, false);
        dispatch(startMult(start))
      }} name={'picStartRS'} /> :
        <div className={s.technologyCard}>
          <div className={s.container}>
            <div className={s.blockTree} >
              <span onClick={() => navigate(-1)} className={s.item}>
                Технологии
              </span>
              <HiOutlineChevronRight />
              <span className={s.item} >
                RS-485
              </span>
            </div>

            <h2>RS-485 - стандарт физического уровня передачи данных</h2>

            <div className={s.blockTop}>

              <div className={s.blockTop}>
                <Mult name={'picRS'} />
              </div>

            </div>

            <h3 className={s.hArhitect}>Архитектура сети RS-485</h3>
            <p className={s.textArhitect}>Данные передаются дифференциально по двум скрученным вместе проводам, называемым «витой парой». 
              Свойства дифференциальных сигналов обеспечивают высокую помехоустойчивость и возможность передачи на большие расстояния. 
              Основные компоненты и принципы архитектуры RS-485:</p>
            <div className={s.blockArhitect}>

              <div className={s.listArhitect}>
                <p className={s.textLeft}>Конечные устройства</p>
                <p className={s.textRight}>Счетчики энергоресурсов (счетчики воды, счетчики тепла), которые собирют данные из своей среды и подключены к шине RS-485.
                    Они взаимодействуют друг с другом, обмениваясь данными по общей витой паре проводов. 
                    </p>
              </div>
              <div className={s.listArhitect}>
                <p className={s.textLeft}>Шлюз</p>
                <p className={s.textRight}>Устройство, которое обеспечивает взаимодействие между сетью RS-485 и другими интерфейсами или протоколами. Шлюз выполняет функции преобразования данных, что позволяет интегрировать устройства RS-485 в более сложные системы или подключать их к другим типам сетей.</p>
              </div>
              <div className={s.listArhitect}>
                <p className={s.textLeft}>Сетевой сервер </p>
                <p className={s.textRight}> Устройство или программное обеспечение, которое обеспечивает централизованное управление, сбор и обработку данных от устройств, подключенных к сети RS-485. Сетевой сервер выступает в роли промежуточного звена между устройствами RS-485 и другими системами, такими как SCADA, облачные платформы или локальные сети.</p>
              </div>
              <div className={s.listArhitect}>
                <p className={s.textLeft}>Сервер приложений</p>
                <p className={s.textRight}> Это программное решение, которое обеспечивает выполнение прикладных задач на основе данных, полученных от устройств, подключенных к сети RS-485</p>
              </div>
            </div>
            <h3 className={s.hTehnology}>Предлагаемые компоненты системы RS-485:</h3>
            <div className={s.listCatalog}>
              {products}

            </div>
            <p className={s.textTarif}> * Для организации сбора данных с приборов учета с дистанционным съемом ООО "ПремексБел" рекомендует приобрести: SIM-карту мобильного оператора МТС с тарифным планом "IoT-сеть" либо SIM-карту мобильного оператора А1 с тарифным планом "Телеметрия NBiot"</p>
            <p className={s.textSlogan}>Свяжитесь с нами для получения предложения или информации!</p>
          </div>
        </div>}
      {!start[2] && <Futter />}
    </div>

  );
};

export default TechnologyCardRS;
